export default __webpack_public_path__ + "static/media/(14).f77cc6ba.jpg";